import { render } from "./Team.vue?vue&type=template&id=4741d3ce&scoped=true"
const script = {}

import "./Team.vue?vue&type=style&index=0&id=4741d3ce&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4741d3ce"]])

export default __exports__